import { FC, useRef } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<unknown> | unknown;
  loading?: boolean;
  title?: string;
  description?: string;
  cancelButton?: string;
  confirmButton?: string;
  colorScheme?: "red" | "blue" | "green" | "yellow";
}

const ConfirmDialog: FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  title = "Hapus Data",
  description = "Anda yakin menghapus data ini?",
  cancelButton = "Batal",
  confirmButton = "Hapus",
  colorScheme = "red",
}) => {
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>{description}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              {cancelButton}
            </Button>
            <Button
              isLoading={loading}
              colorScheme={colorScheme}
              onClick={async () => {
                await onConfirm();
                onClose();
              }}
              ml={3}
            >
              {confirmButton}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ConfirmDialog;
